module.exports = __webpack_public_path__ + "static/media/launch1.51a5c81c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/launch1.jpg
// module id = 390
// module chunks = 0